export default __webpack_public_path__ + "static/media/Teachers_page2.c9b823c2.jpg";